import { Navigate } from "react-router-dom";
import { useAuthContext } from "./FirebaseContext";
import { CircularProgress, Box } from "@mui/material";

export default function AuthGuard({ children }) {
    const { isAuthenticated, isInitialized } = useAuthContext();

    if (!isInitialized) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    // Samo pravi nalog (ne gost) — `isAuthenticated` je već izveden iz `anonymous`
    // claim-a. Neulogovanom otvaramo login prompt na početnoj (?login=1).
    if (!isAuthenticated) {
        return <Navigate to="/?login=1" replace />;
    }

    return <>{children}</>;
}
